module.exports = __webpack_public_path__ + "img/yellow.3540300d.png";